document.addEventListener("DOMContentLoaded", function () {
    const generateBtn = document.getElementById("generatePDF");

    async function generatePDF() {
        const { jsPDF } = window.jspdf;

        // 🧠 Containers se vybírají až TEĎ – po AJAXu!
        const containers = document.querySelectorAll(".label-print .labels-container");

        if (!containers.length || !generateBtn) return;

        const pdfWidth = 677.4;
        const pdfHeight = 381;
        const pdf = new jsPDF("landscape", "mm", [pdfWidth, pdfHeight]);

        for (let i = 0; i < containers.length; i++) {
            const container = containers[i];

            const clone = container.cloneNode(true);
            const wrapper = document.createElement("div");
            wrapper.style.position = "absolute";
            wrapper.style.left = "-9999px";
            wrapper.style.top = "0";
            wrapper.style.width = "1000px";
            wrapper.style.display = "block";
            wrapper.appendChild(clone);
            document.body.appendChild(wrapper);

            await new Promise(resolve => setTimeout(resolve, 50));

            await new Promise(resolve => {
                const images = clone.querySelectorAll("img");
                let loaded = 0;
                if (images.length === 0) return resolve();
                images.forEach(img => {
                    if (img.complete) {
                        loaded++;
                        if (loaded === images.length) resolve();
                    } else {
                        img.onload = img.onerror = () => {
                            loaded++;
                            if (loaded === images.length) resolve();
                        };
                    }
                });
            });

            const canvas = await html2canvas(clone, { scale: 1.5, useCORS: true });
            const imgData = canvas.toDataURL("image/jpeg", 0.9);

            if (i > 0) pdf.addPage([pdfWidth, pdfHeight], "landscape");
            pdf.addImage(imgData, "JPEG", 0, 0, pdfWidth, pdfHeight);

            document.body.removeChild(wrapper);
        }

        const pdfBlob = pdf.output("blob");
        const pdfURL = URL.createObjectURL(pdfBlob);
        const link = document.createElement("a");
        link.href = pdfURL;
        link.download = "Nutrition-PDF.pdf";
        link.click();
    }

    if (generateBtn) {
        generateBtn.addEventListener("click", function () {
            const originalText = generateBtn.textContent;
            generateBtn.textContent = "Wird erstellt";
            generateBtn.classList.add("loading");

            setTimeout(() => {
                generatePDF().then(() => {
                    generateBtn.textContent = originalText;
                    generateBtn.classList.remove("loading");
                });
            }, 1500);
        });
    }
});
